export function WarningIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M1.99166 15.0819L8.84573 3.24305C9.22454 2.58875 9.41394 2.26159 9.66105 2.15172C9.8766 2.05587 10.1227 2.05587 10.3382 2.15172C10.5853 2.26159 10.7747 2.58875 11.1535 3.24305L18.0076 15.0819C18.3878 15.7386 18.5779 16.0669 18.5498 16.3364C18.5253 16.5714 18.4021 16.785 18.211 16.924C17.9919 17.0833 17.6125 17.0833 16.8537 17.0833H3.14556C2.38679 17.0833 2.00741 17.0833 1.78828 16.924C1.59714 16.785 1.474 16.5714 1.4495 16.3364C1.4214 16.0669 1.61149 15.7386 1.99166 15.0819Z" stroke="#D92D20" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10 14.3334V11.0001M10 7.66675H10.0083" stroke="#D92D20" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

WarningIcon.displayName = 'WarningIcon';
